import { Controller } from '@hotwired/stimulus'
import React from 'react'
import { createRoot } from 'react-dom/client'
import CandidateChat from '../components/coach_chat/candidate/CandidateChat'

export default class extends Controller {
  static targets = ['container']
  static values = {
    // Socket and room configuration
    socketUrl: String,
    username: String,
    chatRoom: String,
    inHours: Boolean,
    logChatEventPath: String,
    logChatMissedOpportunityPath: String,
    chatCoachInfoPath: String,
    serverTime: Number,
    currentUserLocale: String,

    // Room API field options for coaches to see candidate information
    userDisplayName: String,
    userFirstName: String,
    videoEnabled: Boolean,
    browserName: String,
    userLocale: String,
    userLanguage: String,
    userCompany: String,
    userCompanyId: String,
    partnerCandidate: Boolean,
    conversationStarter: String,

    // Chat configuration and coach selection
    chatMode: String,
    coachEasyRtcId: String,

    // Additional system fields and user identification
    userId: Number,
    userEmail: String,
    avatar: String,
    os: String,
    buildChatHistoryPath: String,
    candidateCoachChatSurveyPath: String,
    conversationId: String,

    // Device detection and time synchronization
    isMobile: Boolean,
    clientTime: Number,
    timeOffset: Number,

    // User type flags and feature access
    deloitteUser: Boolean,
    userCareerDevelopment: Boolean,
    outplacement: Boolean,
    opRedesign: Boolean,
    afterChatPath: String,
  }

  connect() {
    console.log(
      '[STIMULUS_DEBUG] CandidateChatController connected',
      this.element,
    )
    // Wait for easyrtc to be available before initializing React
    this.waitForEasyRTC()
  }

  disconnect() {
    console.log(
      '[STIMULUS_DEBUG] CandidateChatController disconnected',
      this.element,
    )
    // Clean up React root if it exists
    if (this.reactRoot) {
      this.reactRoot.unmount()
    }
  }

  async waitForEasyRTC() {
    console.log('Waiting for openEasyRtc')
    // Wait for openEasyRtc to be loaded and available on window
    // I only saw it wait once, this is more about bridging `require` and npm dependencies
    while (!window.openEasyRtc) {
      await new Promise((resolve) => setTimeout(resolve, 100))
    }

    console.log('openEasyRtc is available')
    // Now initialize the React component
    this.initializeReactComponent()
  }

  initializeReactComponent() {
    // Create React root and render the component
    this.reactRoot = createRoot(this.containerTarget)

    // Debug logging
    console.log(
      'CandidateChatController - logChatEventPathValue:',
      this.logChatEventPathValue,
    )

    const props = {
      // Socket and room configuration
      socketUrl: this.socketUrlValue,
      username: this.usernameValue,
      chatRoom: this.chatRoomValue,
      inHours: this.inHoursValue,
      log_chat_event_path: this.logChatEventPathValue,
      log_chat_missed_opportunity_path: this.logChatMissedOpportunityPathValue,
      chatCoachInfoPath: this.chatCoachInfoPathValue,
      serverTime: this.serverTimeValue,
      current_user: { locale: this.currentUserLocaleValue },

      // Room API field options for coaches to see candidate information
      userDisplayName: this.userDisplayNameValue,
      userFirstName: this.userFirstNameValue,
      videoEnabled: this.videoEnabledValue,
      browserName: this.browserNameValue,
      userLocale: this.userLocaleValue,
      userLanguage: this.userLanguageValue,
      userCompany: this.userCompanyValue,
      userCompanyId: this.userCompanyIdValue,
      partnerCandidate: this.partnerCandidateValue,
      conversationStarter: this.conversationStarterValue,

      // Chat configuration and coach selection
      chatMode: this.chatModeValue,
      coachEasyRtcId: this.coachEasyRtcIdValue,

      // Additional system fields and user identification
      userId: this.userIdValue,
      userEmail: this.userEmailValue,
      avatar: this.avatarValue,
      os: this.osValue,
      buildChatHistoryPath: this.buildChatHistoryPathValue,
      candidateCoachChatSurveyPath: this.candidateCoachChatSurveyPathValue,
      conversationId: this.conversationIdValue,

      // Device detection and time synchronization
      isMobile: this.isMobileValue,
      clientTime: this.clientTimeValue,
      timeOffset: this.timeOffsetValue,

      // User type flags and feature access
      deloitteUser: this.deloitteUserValue,
      userCareerDevelopment: this.userCareerDevelopmentValue,
      outplacement: this.outplacementValue,
      opRedesign: this.opRedesignValue,
      afterChatPath: this.afterChatPathValue,
    }

    this.reactRoot.render(React.createElement(CandidateChat, props))
  }
}
